import * as moment from 'moment';
import { AdjustedLine, ModifierContext } from '../modifier-models';
import { BaseRule } from '../rule-base';

export class Rule0011 extends BaseRule {
    name = '0011 emergency (+12u / ½h)';

    private calculateMinutes(startTime: string, endTime: string): number {
        if (!startTime || !endTime) return 0;

        try {
            // Parse times in HH:mm format
            const [startHours, startMinutes] = startTime.split(':').map(Number);
            const [endHours, endMinutes] = endTime.split(':').map(Number);

            // Convert to total minutes
            const startTotalMinutes = startHours * 60 + startMinutes;
            const endTotalMinutes = endHours * 60 + endMinutes;

            // Handle case where end time is on next day
            const diff = endTotalMinutes >= startTotalMinutes
                ? endTotalMinutes - startTotalMinutes
                : (24 * 60 - startTotalMinutes) + endTotalMinutes;

            return diff;
        } catch (error) {
            console.error('Error calculating minutes:', error);
            return 0;
        }
    }

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0011') return;

        /* ── minutes ──────────────────────────────────────────────── */
        const minutes = this.calculateMinutes(line.startTime || '', line.endTime || '');
        const blocks = Math.ceil(minutes / 30);
        const newUnits = blocks * 12;

        if (autoApply) {
            line.adjustedUnits = newUnits;

            /* Calculate price based on average price per unit from non-modifier lines */
            if (ctx.totalPrice && ctx.lines) {
                // Get total units from non-modifier lines
                const nonModifierLines = ctx.lines.filter((l: AdjustedLine) => !l.isModifier && !l.isConsult);
                const totalNonModifierUnits = nonModifierLines.reduce((sum: number, l: AdjustedLine) => sum + (l.initialUnits || l.units || 0), 0);

                // Calculate average price per unit
                const pricePerUnit = totalNonModifierUnits > 0 ? ctx.totalPrice / totalNonModifierUnits : 0;

                line.adjustedRand = +(newUnits * pricePerUnit).toFixed(2);
                line.trace.push(`0011: ${blocks} x 12 units (time ${minutes} min) at R${pricePerUnit.toFixed(2)} per unit`);
            }

            line.trace.push(`0011 ${blocks}x½h (${minutes} min) = +${line.adjustedUnits}u`);
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0011',
                message: `Emergency procedure: ${blocks}x½h (${minutes} min) = +${newUnits}u`,
                kind: 'overwrite',
                unitsDelta: newUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(l => {
            if (l.code !== '0011') return;

            /* ── minutes ──────────────────────────────────────────────── */
            const minutes = this.calculateMinutes(l.startTime || '', l.endTime || '');
            const blocks = Math.ceil(minutes / 30);
            l.adjustedUnits = blocks * 12;

            /* Calculate price based on average price per unit from non-modifier lines */
            if (ctx.totalPrice && ctx.lines) {
                // Get total units from non-modifier lines
                //const nonModifierLines = ctx.lines.filter((line: AdjustedLine) => !line.isModifier && !line.isConsult);
                //const totalNonModifierUnits = nonModifierLines.reduce((sum: number, line: AdjustedLine) => sum + (line.initialUnits || line.units || 0), 0);


                /* const hasConsultLines = ctx.lines.some((line: AdjustedLine) => line.isConsult);

                // if we have consult lines for the given day we should push a warning with kind = 'remove' and a message stating
                // that Modifier 0011 does not apply in respect of patients on scheduled lists
                if (hasConsultLines) {
                    l.suggestions = l.suggestions || [];
                    l.suggestions.push({
                        ruleCode: '0011',
                        message: 'Modifier 0011 does not apply in respect of patients on scheduled lists',
                        kind: 'remove'
                    });
                } */

                // Calculate average price per unit
                const totalUnits = ctx.totalUnits || 0;
                const pricePerUnit = totalUnits > 0 ? ctx.totalPrice / totalUnits : 0;

                l.adjustedRand = +(l.adjustedUnits * pricePerUnit).toFixed(2);
                l.trace.push(`0011: ${blocks} x 12 units (time ${minutes} min) at R${pricePerUnit.toFixed(2)} per unit`);
            }

            //l.trace.push(`0011 ${blocks}x½h (${minutes} min) = +${l.adjustedUnits}u`);
        });

        return lines;
    }
}
